/**
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 *
 * THIS FILE IS MANAGED CENTRALLY BY THE `common-code` REPO.
 * IT COULD BE AUTO-REPLACED AT ANY TIME.
 * DO NOT MAKE CUSTOM CHANGES TO THIS FILE.
 * @see https://gitlab.com/dea-aero/development/common-code
 *
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 */
import {createStore as create} from "./util/createStore";


const pathToRegex = (path) => (
    `^${path}$`
        .replaceAll(/\//g, '\\/')
        .replaceAll('*', '.*')  // * matches anything
        .replaceAll(/<path:?[^>]*>/g, '[^<]+')  // <path:xyz> matches aaa/bbb/ccc
        .replaceAll(/<[^>]+>/g, '[^/]+')
);

const _persistOptions = {
    name: 'useLoginStore',
    // Optional: You can specify which parts of the state to persist.
    // Uncomment the 'partialize' function below to only persist the 'count'
    // part of the state.
    // partialize: (state) => ({ count: state.count }),
};

export const useLoginStore = create((set, get) => ({
    id: null,
    user: '',
    image: '',
    groups: [],
    loading: false,
    permissions: [],
    userData: {},
    loginCode: null,
    setId: (id) => set({id}),
    setUser: (user) => set({user}),
    setImage: (image) => set({image}),
    setGroups: (groups) => set({groups}),
    setLoading: (loading) => set({loading}),
    setPermissions: (permissions) => set({permissions}),
    setLoginUserData: (userData) => set({userData}),
    setLoginCode: (loginCode) => set({loginCode}),
    canUser: (method, path) => {
        const {permissions} = get()
        const ret = permissions.some(allowed => {
            if (allowed.method !== method && allowed.method !== '*') {
                return false
            }
            if (allowed.path === path || allowed.path === '*') {
                return true
            }
            if (allowed.path.endsWith('*')) {
                const _allowed_wildcard = allowed.path.replace(/\*$/, '')
                if (path.startsWith(_allowed_wildcard)) {
                    return true
                }
            }
            if (path === '#/') {
                // always allow access to the root page when logged in
                return true
            }
            if (path && path.indexOf('<')) {
                try {
                    const allowed_path_regex = pathToRegex(allowed.path)
                    if (path.match(allowed_path_regex)) {
                        console.log('YES', path, allowed_path_regex)
                        return true
                    }
                } catch (e) {
                    console.error('error in canUser', e)
                    return false
                }
            }
            return false
        })
        return Boolean(ret)
    },
    canRole: (method, path, permissions) => {
        if (path === '#/') {
            // always allow access to the root page when logged in
            return true
        }
        const ret = permissions.some(allowed => {
            if (allowed.method === method || allowed.method === '*') {
                if (allowed.path === path || allowed.path === '*') {
                    return true
                }
                try {
                    const allowed_path_regex = `^${allowed.path}$`
                        .replaceAll(/\//g, '\\/')
                        .replaceAll(/<path:[^>]+>/g, '[^<*]+')
                        .replaceAll(/<[^>]+>/g, '[^/]+')
                        .replaceAll('*', '.*')
                    if (path && path.match(allowed_path_regex)) {
                        console.log('YES', path, allowed_path_regex)
                        return true
                    }
                } catch (e) {
                    console.error('error in canRole', e)
                    return false
                }
            }
            return false
        })
        return Boolean(ret)
    },
}), _persistOptions);
